exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/**\nEssential imports for the global theme, but also to be used in single components\n**/\n.main-stage {\n  overflow: hidden;\n}\n.main-stage__image {\n  background-image: linear-gradient(#ced4da, #dee2e6);\n  background-repeat: no-repeat;\n  background-size: cover;\n  height: 33vh;\n  max-height: 420px;\n}\n@media (max-width: 767px) {\n.main-stage__image {\n    height: 250px;\n}\n}\n.main-stage__spinner {\n  top: 50%;\n  left: 50%;\n}", ""]);

// exports
